import { i18n } from '@fs/zion-locale'

export default {
  notEnoughSearchCriteria: i18n.t('useGroupSearch.notEnoughSearchCriteria', 'Not enough search criteria'),
}
